import { pdfjs } from 'react-pdf';

import { configurePDFWorker } from '@helpers/pdfWorker';

export const isPdfPasswordProtected = async (file: File): Promise<boolean> => {
  const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  if (!isPdf) return false;

  configurePDFWorker();
  const data = await file.arrayBuffer();

  return new Promise<boolean>((resolve) => {
    // Use PDF.js to attempt loading the document without a password
    const task = pdfjs.getDocument({ data });

    // Handle password callback
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (task as any).onPassword = () => {
      task.destroy();
      resolve(true);
    };

    task.promise
      .then((doc) => {
        doc.destroy();
        resolve(false);
      })
      .catch((err: unknown) => {
        const e = err as { name?: string };
        task.destroy();
        if (e?.name === 'PasswordException' || e?.name === 'PasswordError') {
          resolve(true);
        } else {
          resolve(false);
        }
      });
  });
};
